import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ce2813e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "carousel slide",
  id: "carouselExampleCaptions",
  "data-bs-ride": "true"
}
const _hoisted_2 = { class: "carousel-indicators" }
const _hoisted_3 = ["data-bs-slide-to"]
const _hoisted_4 = { class: "carousel-inner" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "carousel-caption" }
const _hoisted_7 = { class: "h5-style" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<button class=\"carousel-control-prev\" type=\"button\" data-bs-target=\"#carouselExampleCaptions\" data-bs-slide=\"prev\" data-v-2ce2813e><span class=\"carousel-control-prev-icon\" aria-hidden=\"true\" data-v-2ce2813e></span><span class=\"visually-hidden\" data-v-2ce2813e>Previous</span></button><button class=\"carousel-control-next\" type=\"button\" data-bs-target=\"#carouselExampleCaptions\" data-bs-slide=\"next\" data-v-2ce2813e><span class=\"carousel-control-next-icon\" aria-hidden=\"true\" data-v-2ce2813e></span><span class=\"visually-hidden\" data-v-2ce2813e>Next</span></button>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carousel, (i, index) => {
        return (_openBlock(), _createElementBlock("button", {
          type: "button",
          "data-bs-target": "#carouselExampleCaptions",
          "data-bs-slide-to": index,
          "aria-current": "true",
          class: _normalizeClass({ active: index == 0,})
        }, null, 10, _hoisted_3))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carousel, (i, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["carousel-item", { active: index == 0}])
        }, [
          _createElementVNode("img", {
            class: "img-fluid w-100",
            src: i.image,
            style: {"object-fit":"cover"}
          }, null, 8, _hoisted_5),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h5", _hoisted_7, _toDisplayString(i.heading), 1)
          ])
        ], 2))
      }), 256))
    ]),
    _hoisted_8
  ]))
}